import { range } from "lodash";
import { Fragment } from "react";

import { Skeleton } from "@/components/elements/Skeleton";

import { MappingGrid } from "./MappingGrid";

export function FieldMappingSkeleton(props: { rows?: number }) {
  return (
    <MappingGrid>
      {range(props.rows ?? 5).map((i) => (
        <Fragment key={i}>
          <div className="flex h-10 items-center">
            <Skeleton className="h-4 w-full" />
          </div>
          <div className="flex flex-none items-center justify-center"></div>
          <div className="flex h-10 items-center">
            <Skeleton className="h-4 w-full" />
          </div>
        </Fragment>
      ))}
    </MappingGrid>
  );
}
